module.exports = __webpack_public_path__ + "media/images/image3-aae5664223f6a57d90c4cf8a0d368789.png";